import { Container, Heading, Text, List, ListItem, Link, Box, VStack, Divider, useColorModeValue } from '@chakra-ui/react';
import MainLayout from '../../components/layout/MainLayout';

const TermsPage: React.FC = () => {
  const textColor = useColorModeValue('gray.700', 'gray.300');
  const headingColor = useColorModeValue('gray.900', 'gray.100');
  const boxBg = useColorModeValue('blue.50', 'blue.900');
  const boxText = useColorModeValue('blue.900', 'blue.100');

  return (
    <MainLayout>
      <Container maxW="3xl" py={8}>
        <VStack align="stretch" spacing={6}>
          <Heading as="h1" size="xl" mb={2} color={headingColor}>Obchodní podmínky</Heading>
          <Text fontSize="sm" color={textColor}>
            Poslední aktualizace: {new Date().toLocaleDateString('cs-CZ')}
          </Text>

          <Box bg={boxBg} p={4} borderRadius="md">
            <Text fontWeight="bold" mb={2} color={boxText}>Shrnutí</Text>
            <Text fontSize="sm" color={boxText}>
              Používáním tohoto webu souhlasíte s níže uvedenými podmínkami. Obsah slouží pro informační účely, bez záruky úplnosti a správnosti. Provozovatel může podmínky a obsah kdykoli měnit.
            </Text>
          </Box>

          <Divider />

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>1. Provozovatel a kontakt</Heading>
            <Text color={textColor} mb={4}>
              Provozovatelem webových stránek je subjekt uvedený v sekci <Link href="/kontakt" color="brand.primary">Kontakt</Link>. Pro veškeré dotazy nebo podněty prosím využijte uvedené kontaktní údaje.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>2. Rozsah a přijetí podmínek</Heading>
            <Text color={textColor} mb={4}>
              Tyto podmínky upravují používání tohoto webu a souvisejících služeb (např. newsletter). Vstupem na web a jeho používáním vyjadřujete souhlas s těmito podmínkami.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>3. Obsah, zdroje dat a práva k duševnímu vlastnictví</Heading>
            <List spacing={2} mb={4} styleType="disc" pl={6} color={textColor}>
              <ListItem><strong>Autorská práva:</strong> Texty, grafika a prvky webu podléhají ochraně autorského práva. Kopírování či šíření je možné pouze s předchozím souhlasem.</ListItem>
              <ListItem><strong>Externí data FAČR:</strong> Informace o zápasech, soutěžích a tabulkách pocházejí z veřejných zdrojů FAČR (<Link href="https://www.fotbal.cz" isExternal color="brand.primary">www.fotbal.cz</Link>) a jsou majetkem FAČR. Zobrazujeme je výhradně pro informační účely.</ListItem>
              <ListItem><strong>Loga klubů a týmů:</strong> Loga náleží příslušným klubům a organizacím a slouží pouze k identifikaci.</ListItem>
              <ListItem><strong>Fotografie a videa:</strong> Mediální obsah může pocházet z různých zdrojů, včetně YouTube a Zonerama. Veškerá práva náleží původním autorům.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>4. Pravidla chování uživatelů</Heading>
            <List spacing={2} mb={4} styleType="disc" pl={6} color={textColor}>
              <ListItem>Neporušujte právní předpisy ani práva třetích osob.</ListItem>
              <ListItem>Nevkládejte škodlivý kód a nepokoušejte se narušit bezpečnost webu.</ListItem>
              <ListItem>Nevyužívejte web k nevyžádané reklamě ani automatizovanému sběru dat (scraping) v rozporu s podmínkami.</ListItem>
            </List>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>5. Newsletter a účty</Heading>
            <Text color={textColor} mb={4}>
              Přihlášení k odběru newsletteru je dobrovolné a lze jej kdykoli odhlásit prostřednictvím odkazu v e‑mailu nebo na stránce <Link href="/newsletter/preferences" color="brand.primary">nastavení newsletteru</Link>.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>6. Odpovědnost a záruky</Heading>
            <Text color={textColor} mb={4}>
              Obsah webu je poskytován „tak jak je“, bez jakýchkoli záruk. Provozovatel neodpovídá za případné škody vzniklé užíváním webu, v nejširším rozsahu povoleném právem. Neodpovídáme za dostupnost a obsah externích odkazů (např. FAČR, YouTube, Zonerama).
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>7. E‑shop a externí služby</Heading>
            <Text color={textColor} mb={4}>
              Pokud web odkazuje na externí e‑shop nebo platební službu, nákup se řídí podmínkami daného poskytovatele. Provozovatel tohoto webu není stranou takového smluvního vztahu, pokud není výslovně uvedeno jinak.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>8. Ochrana osobních údajů a cookies</Heading>
            <Text color={textColor} mb={4}>
              Zpracování osobních údajů se řídí dokumentem <Link href="/zasady-ochrany-osobnich-udaju" color="brand.primary">Zásady ochrany osobních údajů</Link>. Informace o cookies naleznete v <Link href="/pravidla-cookies" color="brand.primary">Pravidlech používání cookies</Link>.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>9. Změny podmínek</Heading>
            <Text color={textColor} mb={4}>
              Provozovatel si vyhrazuje právo tyto podmínky kdykoli upravit nebo doplnit. Změny jsou účinné zveřejněním na tomto webu.
            </Text>
          </Box>

          <Box>
            <Heading as="h2" size="md" mt={4} mb={3} color={headingColor}>10. Rozhodné právo</Heading>
            <Text color={textColor} mb={2}>
              Tyto podmínky se řídí právním řádem České republiky. Případné spory budou řešeny u příslušných soudů České republiky.
            </Text>
            <Text color={textColor}>
              Máte‑li dotazy, kontaktujte nás prostřednictvím stránky <Link href="/kontakt" color="brand.primary">Kontakt</Link>.
            </Text>
          </Box>
        </VStack>
      </Container>
    </MainLayout>
  );
};

export default TermsPage;
